import gql from 'graphql-tag';

// One action for the lead receipt view (webmag-database functions/src/leads/action.ts); `op` picks the operation.
export default gql`
mutation leadReceipts($op: String!, $args: jsonb!) {
  leadReceipts(op: $op, args: $args) {
    result
  }
}
`;
